import React from 'react';

const CheckoutSteps = (props) => {
  return (
    <div className='checkout-step'>
      <div className={props.step1 ? 'line-active' : 'line-inactive'}>Signin</div>
      <div className={props.step2 ? 'line-active' : 'line-inactive'}>Shipping</div>
      <div className={props.step3 ? 'line-active' : 'line-inactive'}>PlaceOrder</div>
    </div>
  );
};

export default CheckoutSteps;
